var _g, _g2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup58(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 191,
    viewBox: "0 0 174 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_276_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.6665 20.5L110.942 36.5263L138.958 53L139.217 85.5L138.958 118L110.942 134.474L82.6665 150.5L54.3915 134.474L26.3749 118L26.1165 85.5L26.3749 53L54.3915 36.5263L82.6665 20.5Z",
    fill: "#363ABF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_276_174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.089 46.0287L83.1665 32.9484L106.244 46.0286L129.111 59.4742L129.321 86L129.111 112.526L106.244 125.971L83.1665 139.052L60.0889 125.971L37.2225 112.526L37.0116 86L37.2225 59.4742L60.089 46.0287Z",
    stroke: "white",
    strokeWidth: 6,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.854 60.25C69.4203 60.2597 67.089 61.2308 65.3682 62.9516C63.6473 64.6725 62.6762 67.0038 62.6665 69.4375C62.6665 74.4827 66.8088 78.625 71.854 78.625C76.8993 78.625 81.0415 74.4827 81.0415 69.4375C81.0415 64.3923 76.8993 60.25 71.854 60.25ZM95.479 60.25C93.0453 60.2597 90.7141 61.2308 88.9932 62.9516C87.2723 64.6725 86.3012 67.0038 86.2915 69.4375C86.2915 74.4827 90.4338 78.625 95.479 78.625C100.524 78.625 104.667 74.4827 104.667 69.4375C104.667 64.3923 100.524 60.25 95.479 60.25ZM71.854 65.5C74.059 65.5 75.7915 67.2325 75.7915 69.4375C75.7915 71.6425 74.059 73.375 71.854 73.375C69.649 73.375 67.9165 71.6425 67.9165 69.4375C67.9165 67.2325 69.649 65.5 71.854 65.5ZM95.479 65.5C97.684 65.5 99.4165 67.2325 99.4165 69.4375C99.4165 71.6425 97.684 73.375 95.479 73.375C93.274 73.375 91.5415 71.6425 91.5415 69.4375C91.5415 67.2325 93.274 65.5 95.479 65.5ZM60.0415 76C54.2665 76 49.5415 80.725 49.5415 86.5C49.5415 89.4216 50.7936 92.0571 52.7414 93.9655C50.9546 95.1712 49.4898 96.7956 48.4745 98.6971C47.4593 100.599 46.9244 102.719 46.9165 104.875H52.1665C52.1665 100.497 55.663 97 60.0415 97C64.42 97 67.9165 100.497 67.9165 104.875H73.1665C73.1586 102.719 72.6237 100.599 71.6085 98.6971C70.5932 96.7956 69.1284 95.1712 67.3416 93.9655C69.2894 92.0571 70.5415 89.4242 70.5415 86.5C70.5415 80.725 65.8165 76 60.0415 76ZM73.1665 104.875C71.5259 107.069 70.5415 109.828 70.5415 112.75H75.7915C75.7915 108.372 79.288 104.875 83.6665 104.875C88.045 104.875 91.5415 108.372 91.5415 112.75H96.7915C96.787 109.911 95.8664 107.149 94.1665 104.875C93.274 103.686 92.1978 102.67 90.9666 101.84C92.9144 99.9321 94.1665 97.2993 94.1665 94.375C94.1665 88.6 89.4415 83.875 83.6665 83.875C77.8915 83.875 73.1665 88.6 73.1665 94.375C73.1665 97.2966 74.4186 99.9321 76.3664 101.84C75.1376 102.666 74.0559 103.692 73.1665 104.875ZM94.1665 104.875H99.4165C99.4165 100.497 102.913 97 107.292 97C111.67 97 115.167 100.497 115.167 104.875H120.417C120.409 102.719 119.874 100.599 118.858 98.6971C117.843 96.7956 116.378 95.1712 114.592 93.9655C116.539 92.0571 117.792 89.4242 117.792 86.5C117.792 80.725 113.067 76 107.292 76C101.517 76 96.7915 80.725 96.7915 86.5C96.7915 89.4216 98.0436 92.0571 99.9914 93.9655C98.2046 95.1712 96.7398 96.7956 95.7245 98.6971C94.7093 100.599 94.1744 102.719 94.1665 104.875ZM60.0415 81.25C62.9736 81.25 65.2915 83.5679 65.2915 86.5C65.2915 89.4321 62.9736 91.75 60.0415 91.75C57.1094 91.75 54.7915 89.4321 54.7915 86.5C54.7915 83.5679 57.1094 81.25 60.0415 81.25ZM107.292 81.25C110.224 81.25 112.542 83.5679 112.542 86.5C112.542 89.4321 110.224 91.75 107.292 91.75C104.359 91.75 102.042 89.4321 102.042 86.5C102.042 83.5679 104.359 81.25 107.292 81.25ZM83.6665 89.125C86.5986 89.125 88.9165 91.4429 88.9165 94.375C88.9165 97.3071 86.5986 99.625 83.6665 99.625C80.7344 99.625 78.4165 97.3071 78.4165 94.375C78.4165 91.4429 80.7344 89.125 83.6665 89.125Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_276_174",
    x: 0.116699,
    y: 0.5,
    width: 173.1,
    height: 190,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.262745 0 0 0 0 0.380392 0 0 0 0 0.933333 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_276_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_276_174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_276_174",
    x: 30.0117,
    y: 29.5,
    width: 106.31,
    height: 121,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_276_174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_276_174",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup58);
export default __webpack_public_path__ + "static/media/Group 58.ca85733f2fb4cfee84d37cf1a9051f6c.svg";
export { ForwardRef as ReactComponent };